import { useState } from 'react'

import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateDeleteExpenseReport } from '../../models/useMutateDeleteExpenseReport'

interface UseDeleteExpenseReportPresenterParams {
  expenseId: number
  onSuccess: () => void
}

export const useDeleteExpenseReportPresenter = ({
  expenseId,
  onSuccess,
}: UseDeleteExpenseReportPresenterParams) => {
  const intl = useProcurifyIntl()
  const { mutate, isLoading } = useMutateDeleteExpenseReport()
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const openConfirm = () => {
    setIsConfirmOpen(true)
  }

  const closeConfirm = () => {
    setIsConfirmOpen(false)
  }

  const deleteExpenseReport = async () => {
    try {
      await mutate(expenseId)

      toast.success({
        title: intl.formatMessage(messages.deleteSuccess, { expenseId }),
      })

      onSuccess()
    } catch (err) {
      const errorMessage = getMessageFromError(err)

      toast.error({
        title: intl.formatMessage(messages.deleteError, {
          expenseId,
          error: errorMessage,
        }),
      })
    }
  }

  return {
    commands: {
      delete: deleteExpenseReport,
      openConfirm,
      closeConfirm,
    },
    states: {
      isDeleting: isLoading,
      isConfirmOpen,
    },
  }
}
